import { IFarm, IIFarm } from '../types';

let listFarms:Array<IIFarm> = [];

let listFarmDetail:Array<IFarm> = [];

let listProducts:any=undefined;

let listPedidosType1:any=undefined;
let listPedidosType2:any=undefined;
let listPedidosType3:any=undefined;

let listPedidosRelated:any=undefined;

class appData {

    static getListFarms(){
        return listFarms;
    }

    static setListFarms(newListFarms:any){
        listFarms=newListFarms;
    }

    static getListFarmDetail(){
        return listFarmDetail;
    }

    static setListFarmDetail(farm:IFarm){
        listFarmDetail.push(farm);
    }

    static getListProducts(){
        return listProducts;
    }

    static setListProducts(newListProducts:any){
        listProducts=newListProducts;
    }

    static getListPedidos(type?: number){
        if (type === 1) return listPedidosType1;
        if (type === 2) return listPedidosType2;
        if (type === 3) return listPedidosType3;
        return listPedidosType1;
    }

    static setListPedidos(newListPedidos:any, type?: number){
        if (type === 1) {
            listPedidosType1 = newListPedidos;
        } else if (type === 2) {
            listPedidosType2 = newListPedidos;
        } else if (type === 3) {
            listPedidosType3 = newListPedidos;
        } else {
            listPedidosType1 = newListPedidos;
        }
    }
    
    static getListPedidosRelated(){
        return listPedidosRelated;
    }

    static setListPedidosRelated(newListPedidosRelated:any){
        listPedidosRelated=newListPedidosRelated;
    }
}
export default appData;